<template>
  <div class="afiliasi-card-wrapper">
    <SOSlotCard :card-type="`none`">
      <template v-slot:card_head>
        <div class="d-grid-2 align-center m-d-12">
          <div>
            <label class="m-d-0">Rekening Tarik Tunai</label>
          </div>
          <div class="j-self-end">
            <div id="btn-change-rekening">
              <SOButton
                :outline="true"
                :full="true"
                :text="`Ubah`"
                :id="`change-rekening`"
                @action="changeRekening"
                @hook:mounted="onMounted"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:card_body>
        <div class="d-grid-2 f-16 f-regular">
          <label class="m-d-8">Nomor Rekening</label>
          <label class="m-d-8 j-self-end f-c-black">{{ rekening.noRekening }}</label>
          <label class="m-d-8">Bank</label>
          <label class="m-d-8 j-self-end f-c-black nama-bank">{{ rekening.namaBank }}</label>
          <label class="m-d-8">Atas Nama</label>
          <label class="m-d-8 j-self-end f-c-black">{{ rekening.pemilik }}</label>
        </div>
      </template>
    </SOSlotCard>
  </div>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
  name: "SOCardRekening",
  props: {
    rekening: {
      type: Object,
      required: true,
    },
  },
  components: {
    SOSlotCard,
    SOButton,
  },
  methods: {
    onMounted() {
      let btn = document.getElementById("btn-change-rekening").childNodes[0].childNodes[0];

      btn.style.padding = "4px 12px";
    },
    changeRekening() {
      this.$router.push({ name: "afiliasi.set_rekening" });
    },
  },
};
</script>
<style scoped src="../styleScope.css"></style>
<style scoped>
.nama-bank {
  width: 60vw;
}
</style>
